import { AppRegister } from "./controllers/RegisterSystem/AppRegister"
import { AppBorrow } from "./controllers/borrowSystem/AppBorrow"
import { AppProfile } from "./controllers/Profile/AppProfile"
import { AppReq } from "./controllers/AppReq/AppReq"
import { AppSupport } from "./controllers/SupportSystem/AppSupport"
import { LoginPage } from './pages/LoginPage'
import { LandingPage } from './pages/LandingPage'
import { RePasswordPage } from "./pages/RegisterSystem/RePasswordPage"
import { AppOfficer } from "./controllers/Officer/AppOfficer"


const AppRoutes = [
    {
        index: true,
        // path: '/login',
        element: <LoginPage />
    },
    {
        path: '/menu',
        element: <LandingPage />
    },
    {
        path: '/registeration/*',
        element: <AppRegister />
    },
    {
        path: '/borrowing/*',
        element: <AppBorrow />
    },
    {
        path: '/officer/*',
        element: <AppOfficer />
    },
    {
        path: '/supporting/*',
        element: <AppSupport />
    },
    {
        path: '/profile/*',
        element: <AppProfile />
    },
    {
        path: '/request/*',
        element: <AppReq />
    },
    {
        path: '/forget-password',
        element: <RePasswordPage />
    }
];

export default AppRoutes;
